import React from 'react';
import Col from 'react-bootstrap/Col';
import Skeleton from 'react-loading-skeleton';
import ShoppingCartProgressBar from '../../../components/ecommerce/shopping-cart-progress/shopping-cart-progress.component';
import ShoppingCartHeader from '../../../components/commons/shopping-cart-header/shopping-cart-header';

function AssignAttendeeHeaderComponent({ MainContent }) {
  return (
    <>
      <ShoppingCartProgressBar />
    </>
  );
}

export default AssignAttendeeHeaderComponent;
